import type { MonitorPreset } from "./types"

const CALIBRATION_STORAGE_KEY_PREFIX = "dataReview.eegCalibration."
const CALIBRATION_SCHEMA_VERSION = 1
const MAX_CALIBRATION_RECORDS = 10

// ISO/IEC 7810 specifications for ID-1-sized cards
const ISO_CARD_WIDTH_MM = 85.6
const ISO_CARD_HEIGHT_MM = 53.98

const MONITOR_PRESETS: MonitorPreset[] = [
	{ label: '14"', diagonalInches: 14, aspectRatio: 16 / 10 },
	{ label: '24"', diagonalInches: 24, aspectRatio: 16 / 9 },
	{ label: '27"', diagonalInches: 27, aspectRatio: 16 / 9 },
]
const MANUAL_PRESET = "Manual"

// The default px/mm is calculated based on a DPI of 96
const DEFAULT_PX_PER_MM = 96 / 25.4

// min & max are 60% and 220% of default (values are arbitrary)
const MIN_PX_PER_MM = DEFAULT_PX_PER_MM * 0.6
const MAX_PX_PER_MM = DEFAULT_PX_PER_MM * 2.2

const KEYBOARD_STEP_MM = 0.2
const SHIFT_MULTIPLIER = 5
const RULER_LENGTH_MM = 50

export {
	CALIBRATION_STORAGE_KEY_PREFIX,
	CALIBRATION_SCHEMA_VERSION,
	MAX_CALIBRATION_RECORDS,
	ISO_CARD_WIDTH_MM,
	ISO_CARD_HEIGHT_MM,
	MONITOR_PRESETS,
	DEFAULT_PX_PER_MM,
	MIN_PX_PER_MM,
	MAX_PX_PER_MM,
	KEYBOARD_STEP_MM,
	SHIFT_MULTIPLIER,
	RULER_LENGTH_MM,
	MANUAL_PRESET,
}
